<template>
    <div class="col-12 mx-auto">
        <div v-if="eventId && !details">
            <div class="loader" v-if="loading"></div>
            <div v-else>
                <!--<p>EventFormIds: {{eventFormIds}}</p>-->
                <div class="form-group" v-if="!isLockedForEdit">
                    <button v-if="canWriteRankingCriteria && !showEditModal" type="button" class="btn btn-primary"
                            :disabled="saving"
                            @click="showSelector = true">
                        <i class="fas fa-plus"></i>
                        {{$t('buttons.add.btnText')}}
                    </button>
                    <button v-if="showEditor && canWriteRankingCriteria && !showEditModal" type="button" class="btn btn-success"
                            :disabled="saving"
                            @click="editBtnClick">
                        <i class="far fa-edit"></i>
                        {{$t('buttons.criteriaForEventEdit.btnText')}}
                    </button>
                    <button v-if="showEditor && canDeleteRankingCriteria && !showEditModal" type="button" class="btn btn-danger"
                            :disabled="saving"
                            @click="deleteRankingCriteria">
                        <i class="far fa-trash-alt"></i>
                        {{$t('buttons.criteriaForEventEditDelete.btnText')}}
                    </button>
                </div>

                <RankingCriteriaEditCard v-model="model"
                                         v-if="showEditor"
                                         :createNew="false"
                                         :readonly="!showEditModal"
                                         :showBtns="showEditModal"
                                         @save="onEdit"
                                         @cancel="onEditClose">
                </RankingCriteriaEditCard>

                <div class="form-group" v-if="!isLockedForEdit && showEditor">
                    <button v-if="canWriteRankingCriteria && !showEditModal" type="button" class="btn btn-primary"
                            :disabled="saving"
                            @click="showSelector = true">
                        <i class="fas fa-plus"></i>
                        {{$t('buttons.add.btnText')}}
                    </button>
                    <button v-if="canWriteRankingCriteria && !showEditModal" type="button" class="btn btn-success"
                            :disabled="saving"
                            @click="editBtnClick">
                        <i class="far fa-edit"></i>
                        {{$t('buttons.criteriaForEventEdit.btnText')}}
                    </button>
                    <button v-if="canDeleteRankingCriteria && !showEditModal" type="button" class="btn btn-danger"
                            :disabled="saving"
                            @click="deleteRankingCriteria">
                        <i class="far fa-trash-alt"></i>
                        {{$t('buttons.criteriaForEventEditDelete.btnText')}}
                    </button>
                </div>
            </div>
        </div>

        <SelectorModal :show.sync="showSelector" :select="onRankingCriteriaSelect" :eventFormIds="eventFormIds"></SelectorModal>
    </div>
</template>

<script>
    import service from "../../services/rankingCriteria.service";
    import { RankingCriteria } from '../../models/models';
    import { EventClaims } from '../../models/enums';
    import RankingCriteriaEditCard from '../../components/rankingCriteria/RankingCriteriaEditCard';
    import SelectorModal from '../../components/rankingCriteria/selector.modal';
    import { mapGetters } from 'vuex';

    export default {
        inject: ['$validator'],
        props: {
            details: {
                type: Boolean,
                default: false
            },
            details: {
                type: Boolean,
                default: false
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            },
            eventFormIds: [String, Number]
        },
        components: {
            RankingCriteriaEditCard,
            SelectorModal,
        },
        data() {
            return {
                loading: false,
                saving: false,
                showSelector: false,
                model: new RankingCriteria(),
                showEditModal: false,
                showPopup: false
            }
        },
        methods: {
            loadRankingCriteria() {
                this.loading = true;
                service
                    .getForEventId(this.eventId)
                    .then(response => {
                        if (response.data) {
                            this.model = new RankingCriteria(response.data);
                        } else {
                            this.model = new RankingCriteria();
                        }
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.loading = false; });
            },
            onRankingCriteriaSelect(ids) {
                kendo.confirm(this.$t('rankingCriteria.confirmations.addToEvent'))
                    .then(function () {
                        this.saving = true;
                        service
                            .addToEvent(this.eventId, ids)
                            .then(response => {
                                this.$vs.notify({
                                    title: this.$t('buttons.add.action'),
                                    text: this.$helpers.responseMessage(response),
                                    color: 'success',
                                    time: this.$store.getters.notificationDuration,
                                })
                            })
                            .catch(error => {
                                this.$vs.notify({
                                    title: this.$t('buttons.add.action'),
                                    text: this.$helpers.errorText(error),
                                    color: this.$helpers.errorColor(error),
                                    time: this.$store.getters.notificationDuration
                                })
                            }).then(() => { this.saving = false; this.loadRankingCriteria() });
                    }.bind(this));
            },
            deleteRankingCriteria() {
                kendo.confirm(`${this.$t('rankingCriteria.confirmations.delete')} '${this.model.name}'?`)
                    .then(function () {
                        this.saving = true;
                        service
                            .deleteFromEvent(this.eventId)
                            .then(response => {
                                this.model = new RankingCriteria();

                                this.$vs.notify({
                                    title: this.$t('buttons.delete.action'),
                                    text: this.$helpers.responseMessage(response),
                                    color: 'success',
                                    time: this.$store.getters.notificationDuration,
                                })
                            })
                            .catch(error => {
                                this.$vs.notify({
                                    title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                    text: this.$helpers.errorText(error),
                                    color: this.$helpers.errorColor(error),
                                    time: this.$store.getters.notificationDuration
                                })
                            }).then(() => { this.saving = false; $('html, body').animate({ scrollTop: 0 }, 'fast'); });

                    }.bind(this));
            },
            haveClaimReadRights(claim) {
                if (!claim) {
                    return false;
                }

                if (claim.read || claim.create || claim.update || claim.delete) {
                    return true;
                }

                return false;
            },
            haveClaimWritePermisions(claim) {
                if (!claim) {
                    return false;
                }

                if (claim.create || claim.update) {
                    return true;
                }

                return false;
            },
            haveClaimDeletePermisions(claim) {
                if (!claim) {
                    return false;
                }

                if (claim.delete) {
                    return true;
                }
            },
            editBtnClick() {
                this.showEditModal = true;
            },
            onEdit(item) {
                this.showEditModal = false;
                this.showPopup = false;
                this.loadRankingCriteria();
            },
            onEditClose() {
                this.showEditModal = false;
                this.showPopup = false;
            },
        },
        mounted() {
            this.loadRankingCriteria();
        },
        computed: {
            ...mapGetters(['isEnVersion', 'currentRegister', 'eventClaims']),
            eventId() {
                return this.currentRegister.registerEntryId;
            },
            canReadRankingCriteria() {
                const claim = this.$store.getters.eventClaims[EventClaims.RankingCriteria];
                const canRead = this.haveClaimReadRights(claim);
                return canRead;
            },
            canWriteRankingCriteria() {
                const claim = this.$store.getters.eventClaims[EventClaims.RankingCriteria];
                const canWrite = this.haveClaimWritePermisions(claim);
                return canWrite;
            },
            canDeleteRankingCriteria() {
                const claim = this.$store.getters.eventClaims[EventClaims.RankingCriteria];
                const canDelete = this.haveClaimDeletePermisions(claim);
                return canDelete;
            },
            showEditor() {
                if (!this.model || !this.model.registerEntityId) {
                    return false;
                }

                return this.model.registerEntityId > 0;
            }
        }
    }
</script>
